import React from 'react'
import styles from './MySubscription.module.css'
import Text from '../../components/text/Text'
import { Wallet } from '../../components/wallet/wallet.component'
import { Subscription } from '../../components/subscription/subscription.component'
import { BussinesElement } from '../../components/subscription/bussinesElement.component'

export function MySubscription() {
    const handleClickSubscription = (value: any) => {
        console.log(value)
    }

    return (
        <div className={styles.container}>
            <Text
                label="Tus planes:"
                fontSize={27}
                color="#184287"
                fontWeight={400}
                marginBottom={15}
            />
            <div className={styles.content}>
                <Subscription
                    image="woman"
                    name="PRO"
                    commerceName="Cafeteria Juanita"
                    date="agosto 02, 2024"
                    data={{}}
                    onClick={handleClickSubscription}
                />
                <Subscription
                    image="men"
                    name="ESTANDAR"
                    commerceName="Cafeteria Juanita"
                    date="agosto 02, 2024"
                    data={{}}
                    onClick={handleClickSubscription}
                />
            </div>
            <Text
                label="Tus complementos:"
                fontSize={27}
                color="#184287"
                fontWeight={400}
                marginBottom={15}
            />
            <div className={styles.content}>
                <Subscription
                    image="woman"
                    name="ANÁLISIS DE TU NEGOCIO"
                    commerceName="Cafeteria Juanita"
                    date="agosto 02, 2024"
                    element={
                        <BussinesElement
                            title="Ventas Totales"
                            content="2,256"
                            subtitle="Ultima Semana"
                        />
                    }
                />
            </div>
            <Text
                label="Tus tarjetas"
                fontSize={27}
                color="#184287"
                fontWeight={400}
                marginBottom={15}
            />
            <Wallet name="Crédito" number="XXXX XXXX XXX 2250" />
        </div>
    )
}
